import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import useIsDarkMode from '../hooks/useIsDarkMode';

ChartJS.register(ArcElement, Tooltip, Legend);

const ChartPublico = ({ datos, tiempoRestante }) => {
  const isDark = useIsDarkMode();
  // Validar y sanitizar los datos antes de enviarlos a Chart.js
  let datosValidados = {
    labels: ['Opción A', 'Opción B', 'Opción C', 'Opción D'],
    datasets: [{
      data: [0, 0, 0, 0],
      backgroundColor: [
        'rgba(255, 99, 132, 0.6)',
        'rgba(54, 162, 235, 0.6)',
        'rgba(255, 205, 86, 0.6)',
        'rgba(75, 192, 192, 0.6)'
      ],
      borderWidth: 1
    }]
  };

  // Solo procesar datos si existen y tienen la estructura esperada
  if (datos && typeof datos === 'object' && datos.datasets && Array.isArray(datos.datasets)) {
    try {
      // Procesar cada dataset
      const datasetsProcesados = datos.datasets.map(dataset => {
        // Asegurar que todos los valores en 'data' sean números válidos
        const dataProcesada = Array.isArray(dataset.data) ? dataset.data.map(value => {
          const numValue = Number(value);
          // Verificar que sea un número finito y no NaN
          if (isNaN(numValue) || !isFinite(numValue) || numValue < 0) {
            return 0;
          }
          return numValue;
        }) : [0, 0, 0, 0]; // Valor por defecto si no hay datos válidos

        // Asegurar que haya exactamente 4 valores para evitar problemas de renderizado
        while (dataProcesada.length < 4) {
          dataProcesada.push(0);
        }

        // Asegurar que el backgroundColor sea un array válido con 4 colores
        const backgroundColor = Array.isArray(dataset.backgroundColor) && dataset.backgroundColor.length >= 4 ?
          dataset.backgroundColor.slice(0, 4) :
          [
            'rgba(255, 99, 132, 0.6)',
            'rgba(54, 162, 235, 0.6)',
            'rgba(25, 205, 86, 0.6)',
            'rgba(75, 192, 192, 0.6)'
          ];

        return {
          ...dataset,
          data: dataProcesada,
          backgroundColor: backgroundColor,
          borderWidth: dataset.borderWidth || 1
        };
      });

      // Procesar labels
      const labelsProcesados = Array.isArray(datos.labels) ?
        datos.labels.slice(0, 4).map(label => String(label || 'Opción')) :
        ['Opción A', 'Opción B', 'Opción C', 'Opción D'];

      datosValidados = {
        labels: labelsProcesados,
        datasets: datasetsProcesados
      };

    } catch (error) {
      console.error('Error al procesar los datos del gráfico:', error);
      // Usar datos por defecto en caso de error
      datosValidados = {
        labels: ['Opción A', 'Opción B', 'Opción C', 'Opción D'],
        datasets: [{
          data: [0, 0, 0, 0],
          backgroundColor: [
            'rgba(255, 99, 132, 0.6)',
            'rgba(54, 162, 235, 0.6)',
            'rgba(255, 205, 86, 0.6)',
            'rgba(75, 192, 192, 0.6)'
          ],
          borderWidth: 1
        }]
      };
    }
  }

  // Opciones del gráfico con validación para evitar errores de renderizado
  const opcionesGrafico = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          color: isDark ? '#e2e8f0' : '#334155',
          font: {
            size: 10 // Reducir el tamaño de fuente para que quepan mejor las etiquetas
          },
          padding: 8, // Reducir el padding entre elementos de la leyenda
          usePointStyle: true, // Usar puntos en lugar de cajas para ahorrar espacio
          pointStyle: 'circle'
        }
      }
    },
    // Evitar errores de renderizado cuando los datos cambian rápidamente
    animation: {
      duration: 200, // Reducir la duración de la animación para actualizaciones más rápidas
    }
  };

  return (
    <div className="w-full max-w-sm sm:max-w-lg mx-auto h-72 sm:h-96 flex-col justify-center items-center">
      <h3 className="text-base sm:text-lg font-semibold text-center mb-2 sm:mb-3 text-black dark:text-white">Opinión del público</h3>
      <div className="flex-grow w-full flex items-center justify-center">
        <Pie data={datosValidados} options={opcionesGrafico} />
      </div>
      <div className="mt-2 sm:mt-3 text-center w-full">
        <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-300">
          Tiempo restante: {tiempoRestante} segundos
        </p>
      </div>
    </div>
  );
};

export default ChartPublico;
